//BKP

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './_style.scss';
import '../../scss/forms.scss';
import '../../scss/modal.scss';

import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Row, Col, Card, CardHeader, CardBody, Label, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { 
    FiltroDinamico,
    GridDinamico,
    dynamicFilterStore,
    clear,
} from '@newspacebpo/newspace-react-grid-filter-bfveic';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as ExcluirActions from '../../store/ducks/protocolo/excluir/actions';

import DynamicForm from '../DynamicForm';
import warning from '../../assets/img/brand/warning.svg';
import {SelectAllAction} from '../SelectAllAction';

import { toast } from 'react-toastify';

import { queryBuilder } from '../../util/routeActions';
import { redirectHandled } from '../../util/helper';
import { getTotaisProtocolo } from '../../services/protocolos';
import { MAX_ITENS_POR_PROTOCOLO } from '../../constants/protocolo';

const statusBloqueio = ["RECTOTAL", 'RECPARCIAL'];
const motivos = [
    {
        codigo: 1,
        unico: true,
        chave: "NUMENVERRADO",
        nome: "Numero de envelope errado"
    },
    {
        codigo: 2,
        unico: false,
        chave: "ENVEXT",
        nome: "Envelope extraviado, necessário novo protocolo"
    },
    {
      codigo: 3,
      unico: false,
      chave: "INCCTTERRADO",
      nome: "Inclusão de contrato errado"
    },
    {
        codigo: 4,
        unico: false,
        chave: "OUTROS",
        nome: "Outros"
    }
];
const setMotivos = {
    unico: [3, 4],
    multiplo: [1, 2, 4],
    unico_multiplo: [3,1,2,4]
}

class Excluir extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mostrarTabela: false,
            modalExcluirProtocoloSucesso: false,
            modalBloqueio: false,
            modalBloqueioFilhos: false,
            mostrarMotivo: false,
            itemSelecionado: {},
            sizePerPage: MAX_ITENS_POR_PROTOCOLO,
            labelBtnExcluir : 'Excluir Contrato',
        };
        this.options = {
            sortIndicator: true,
            hideSizePerPage: true,
            paginationSize: 3,
            hidePageListOnlyOnePage: true,
            clearSearch: true,
            alwaysShowAllBtns: false,
            withFirstAndLast: false,
            sizePerPage: this.state.sizePerPage,
            noDataText: 'Não existem dados para exibição.'
        }

        this.gridAcoes = this.gridAcoes.bind(this);
        this.changeLabelBotaoExcluir = this.changeLabelBotaoExcluir.bind(this);
    }

    async componentDidMount() {

        const search = this.props.location.search
        const params = new URLSearchParams(search)
        var path = params.toString()


        const sizePerPage = await getTotaisProtocolo();
        this.setState({sizePerPage});

      }

    componentDidUpdate() {
      const {
        actions,
        data: {
          protocolo_excluido,
        }
      } = this.props;

      if(protocolo_excluido) {
          this.limparConsulta()
          actions.clearStatus()
      }

    }

    handleSelecionarTodos = () => {

      const { actions, data: { selecionarTodos } } = this.props;

      if(this.props.data.protocolos.some( ({isSelected}) => !!isSelected )) this.invisibleMotivo();

      actions.selectMultiples(!selecionarTodos);

      if(this.state.mostrarMotivo) {
        actions.searchReasonRequest();
      }

    };

    toggleModalExcluirProtocoloSucesso = () => {
        this.setState({
            modalExcluirProtocoloSucesso: !this.state.modalExcluirProtocoloSucesso
        });
    }

    toggleModalBloqueio = (row = {}) => {
        this.setState({
            modalBloqueio: !this.state.modalBloqueio,
            itemSelecionado: row
        });
    }

    toggleModalBloqueioFilhos = () => {
        this.setState({
            modalBloqueioFilhos: !this.state.modalBloqueioFilhos
        });
    }

    visibleTable = () => {
        this.setState({ mostrarTabela: true })
        this.setState({ mostrarMotivo: false })
    }

    visibleMotivo = () => {
        this.setState({ mostrarMotivo: true })
    }
    
    invisibleMotivo = () => {
        this.setState({ mostrarMotivo: false })
    }

    getConfigExclusao = () => {
        const contratos = dynamicFilterStore.getState().dynamicFilters.data;
        const contratosSelecionados = contratos.filter((el) => el.isSelected);
        let codigoMotivos = setMotivos.unico;

        const protocolos = contratosSelecionados.reduce((acc, row) => {
            if(!acc[row.IdProtocolo]){
                acc[row.IdProtocolo] = {
                    qtdContratos: 1,
                    qtdContratosNoProtocolo: row.QtdContratosProtocolo,
                }
            }else{
                acc[row.IdProtocolo].qtdContratos++;
            }
            return acc;
        }, {});

        if(Object.entries(protocolos).length != 1) {
            codigoMotivos = setMotivos.unico_multiplo;
        }else{
            for (const [protocolo, qtds] of Object.entries(protocolos)) {
                codigoMotivos = (qtds.qtdContratos === qtds.qtdContratosNoProtocolo) 
                ? setMotivos.unico_multiplo
                : codigoMotivos = setMotivos.unico
            }
        }
        return {
            reasons: motivos.filter( (r) => codigoMotivos.includes(r.codigo)),
            loading: false, error: false
        }
    }

    invisibleTable = () => {
        this.setState({ mostrarTabela: false })
    }

    excluir = () => {

        const listaContratos = dynamicFilterStore.getState().dynamicFilters.data.filter((el) => el.isSelected);

        if(!listaContratos.length) {
            toast.error("Selecione pelo menos um contrato para excluir")
            return false;
        }

        let motivos_check = document.querySelectorAll('.motivo_check:checked');
        let motivos_outros = document.getElementById("textarea-input").value
        let motivos_codigo = Array.from(motivos_check).map((item) => {
            return item.value
        })

        const motivo = motivos.find(motivo => motivos_codigo.includes(motivo.codigo.toString())).chave;

        if(!motivos_codigo.length) {
            toast.error("Selecione pelo menos um motivo para excluir")
            return false;
        }

        if(motivo==='OUTROS'){
            let error = false;
            let message = '';
            if(!motivos_outros) {
                message = "Favor digitar uma observação";
                error = true;
            }else if(motivos_outros.length < 5){
                message = "Explique melhor o motivo";
                error = true;                
            }
            if(error) {
                toast.error(message);
                return false;
            }
        }

        let payload = {
            listaContratos,
            motivo,
            observacao: motivos_outros,
        }

        this.props.actions.deleteRequest(payload);

    }

    limparConsulta = () => {
        this.invisibleMotivo();
        clear();
    }

    remove = (rowId) => {
        const arrayCopy = this.state.data.filter((row) => row.id !== rowId);
        this.setState({ data: arrayCopy });
    };

    selectContrato = ( id ) => {
      const {
        actions,
        data,
      } = this.props;

      actions.select(id);

      if(data.protocolos.every(({ isSelected }) => !isSelected)){
        this.invisibleMotivo()
      } else if(this.state.mostrarMotivo) {
        actions.searchReasonRequest();
      }
    }

    changeLabelBotaoExcluir = (row) => {
        const { data } = dynamicFilterStore.getState().dynamicFilters;
        const contratosSelecionados = data.filter((el) => el.isSelected);
        this.setState({ labelBtnExcluir : data.length === contratosSelecionados.length ? 'Excluir Protocolo' : 'Excluir Contrato' });
    }
    
    botaoExcluir = () => {
        const excluir = dynamicFilterStore.getState().dynamicFilters.data.filter((el) => el.isSelected);;
        if(excluir.length === 0 ) {
          toast.error("Selecione pelo menos um contrato.")
          return false
        }
        
        this.visibleMotivo()
        this.props.actions.searchReasonRequest();
    };

    handleViewProtocolo = (e, row) => {
      redirectHandled(this.props.history, `protocolo/consulta/visualizar/${row.IdProtocolo}`);
    }

    gridAcoes = () => {
        return [
            {
                icon: "fa fa-eye acoes_mg_left",
                action: (e, row) => this.handleViewProtocolo(e, row),
                buttonColor: "ghost-primary",
            },
            {
                type: "checkbox",
                disabled: (row) => row.StatusContrato > 0 || row.TemFIlhos || statusBloqueio.includes(row.StatusProtocolo),
            },
            {
                icon: "fa fa-exclamation-triangle",
                action: (e, row) => this.toggleModalBloqueioFilhos(),
                buttonColor: "ghost-primary",
                show: (row) => !statusBloqueio.includes(row.StatusProtocolo) && row.TemFilhos,
            },
            {
                icon: "fa fa-exclamation-triangle",
                action: (e, row) => this.toggleModalBloqueio(row),
                buttonColor: "ghost-primary",
                show: (row) => statusBloqueio.includes(row.StatusProtocolo),
            }
        ];
    }

    render() {
        const {
            reasons,
        } = this.getConfigExclusao();
        const {
          modalBloqueio,
          itemSelecionado,
          modalBloqueioFilhos,
          mostrarMotivo,
          modalExcluirProtocoloSucesso,
        } = this.state;

        const selectRowProp = {
            mode: 'checkbox',
            clickToSelect: true,
            hideSelectColumn: true,
            onSelect: (row) => {
                this.selectContrato(row.uuid);
                return true;
            }
        };

        return (
            <Row>
                <Col sm={12} md={12} style={{ flexBasis: 'auto' }}>

                    <Modal isOpen={modalBloqueio} toggle={this.toggleModalBloqueio} className="modal-md modal-default">
                        <ModalHeader>Atenção</ModalHeader>
                        <ModalBody>

                            <div className="container-image">
                                <img className="alert" src={warning} alt="alerta" />
                            </div>

                            <p className="text-alert error">Não foi possível excluir o protocolo pois o mesmo se encontra no status: 
                              <strong>
                                { itemSelecionado.StatusDescricao ? itemSelecionado.StatusDescricao : "" }
                              </strong>
                            </p>

                        </ModalBody>
                        <ModalFooter>
                            <Button className="btn_success" onClick={this.toggleModalBloqueio}>Fechar</Button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={modalBloqueioFilhos} toggle={this.toggleModalBloqueioFilhos} className="modal-md modal-default">
                        <ModalHeader>Atenção</ModalHeader>
                        <ModalBody>

                            <div className="container-image">
                                <img className="alert" src={warning} alt="alerta" />
                            </div>
                            <p className="text-alert error">Não foi possível excluir o protocolo pois o mesmo possui protocolos de Complemento/Regularização.</p>

                        </ModalBody>
                        <ModalFooter>
                            <Button className="btn_success" onClick={this.toggleModalBloqueioFilhos}>Fechar</Button>
                        </ModalFooter>
                    </Modal>

                    <Card>
                        <CardHeader>
                            <i className="icon-note"></i><strong>Exclusão de Protocolos</strong>{' '}
                        </CardHeader>
                        <CardBody>
                            <FiltroDinamico
                                {...this.props}
                                name="protocolo-excluir"
                                filterRequired
                                service="protocolo"
                            />

                            <Row className="mt-3 row_excluirProtocolo" sm={2} md={12} style={{}}>
                                    <Col sm={12} md={8}>
                                        <GridDinamico
                                            pagination={false}
                                            tableActions={this.gridAcoes()}
                                            onSelect={this.changeLabelBotaoExcluir}
                                            onSelectAll={this.changeLabelBotaoExcluir}
                                        />
                                        <div class="mt-5 text-center">
                                            <Button color="secondary" onClick={this.botaoExcluir}>
                                                { this.state.labelBtnExcluir }
                                            </Button>
                                        </div>
                                    </Col>
                                {mostrarMotivo &&
                                    <Col sm={12} md={4}>
                                        <Card>
                                            <CardHeader>
                                                <i className="icon-note"></i><strong>Motivo</strong>{' '}
                                            </CardHeader>
                                            <CardBody>
                                                <Modal isOpen={modalExcluirProtocoloSucesso} toggle={this.toggleModalExcluirProtocoloSucesso} className="modal-md modal-default header-success">
                                                    <ModalHeader toggle={this.toggleModalExcluirProtocoloSucesso}>Exclusão de protocolo</ModalHeader>
                                                    <ModalBody>
                                                        <p className="text-alert">Protocolo excluído com sucesso!</p>
                                                    </ModalBody>
                                                    <ModalFooter>
                                                        <Button className="btn_success" onClick={this.toggleModalExcluirProtocoloSucesso}>Fechar</Button>
                                                    </ModalFooter>
                                                </Modal>

                                                {reasons.map( (reason) => (
                                                    <Row key={reason.codigo}>
                                                        <Col sm={12} md={12}>
                                                            <div className="form-check">
                                                                <Input className="form-check-input motivo_check" type="radio" name="motivo_check" value={reason.codigo} />
                                                                <Label className="form-check-label">{reason.nome}</Label>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                ))}
                                                <Row className="mt-3">
                                                    <Col sm={12} md={12}>
                                                        <Input
                                                            innerRef={element => (this.motivo_outros = element)}
                                                            type="textarea"
                                                            name="textarea-input"
                                                            id="textarea-input"
                                                            rows="4"
                                                            placeholder="300 Caracteres..." />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm={12} md={12} className="d-flex justify-content-center align-items-center" style={{ height: '100%', paddingTop: '5%' }}>
                                                        <Button className="btn btn_success flex-fill" onClick={this.excluir}>
                                                            Confirmar
                                                    </Button>
                                                        <Button className="btn btn_danger flex-fill" onClick={this.invisibleMotivo}>
                                                            Cancelar
                                                    </Button>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                }
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row >
        )
    }
}

const mapStateToProps = state => ({
    data: state.protocoloExcluir
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(ExcluirActions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Excluir);
